export default __webpack_public_path__ + "static/media/entretienpourmethode.e6948fde.jpg";